import styled from 'styled-components';

export const List = styled.ul`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
	margin: 0;
	padding: 0;
	list-style: none;
`;

export const ListItem = styled.li`
	flex: 1;
	margin: 0 1rem;
	padding: 0;
`;
